import React from 'react';
import { useQueryString } from '@/utils/hooks';
import { useLocation } from 'react-router';
import SplashPage from '../SplashPage';
import { Trans } from '@lingui/react/macro';

interface ExternalUserRequestProps {}

interface QueryStringParams {
    email?: string;
}

const ExternalUserRequest = ({}: ExternalUserRequestProps) => {
    const location = useLocation();
    const { email } = useQueryString<QueryStringParams>(location);
    return (
        <SplashPage>
            <h3>
                <Trans>Link user</Trans>
            </h3>
            <Trans>
                You already have an account with Rubus. You need to link that account to your Plyo account. An email has been
                sent to {email} with further instructions. You must click 'accept' in this email to gain access to the
                property.
            </Trans>
        </SplashPage>
    );
};

export default ExternalUserRequest;
